import { combineReducers } from "redux";
import {
  _FAILURE,
  _SUCCESS,
  FETCH_COOPERATION_DOCUMENTS_REQUEST,
  ADD_COOPERATION_DOCUMENT_REQUEST,
  DELETE_COOPERATION_DOCUMENT_REQUEST,
} from "./constants";
import { Action } from "./types";
import { CooperationDocument } from "../types";

const initialState: CooperationDocument[] = [];

function items(state = initialState, action: Action): CooperationDocument[] {
  let newState = null;
  switch (action.type) {
    case FETCH_COOPERATION_DOCUMENTS_REQUEST + _SUCCESS:
      return action.payload;

    case ADD_COOPERATION_DOCUMENT_REQUEST + _SUCCESS:
      return [...state, action.payload];

    case DELETE_COOPERATION_DOCUMENT_REQUEST + _SUCCESS:
      newState = state?.filter((doc) => doc.id !== action.data.documentId);
      return newState;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action) {
  switch (action.type) {
    case FETCH_COOPERATION_DOCUMENTS_REQUEST:
      return true;

    case FETCH_COOPERATION_DOCUMENTS_REQUEST + _SUCCESS:
    case FETCH_COOPERATION_DOCUMENTS_REQUEST + _FAILURE:
      return false;

    default:
      return state;
  }
}

export const cooperationDocuments = combineReducers({ items, isFetching });
